/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="./serviceMover.controller.ts" />
module Meevo.Components.Controls {
    "use strict";

    export class ServiceMover implements angular.IDirective {
        restrict = "E";
        templateUrl = "app/components/controls/serviceMover/serviceMover.template.html";
        scope = {
            categories: '=?',
            centralOffice: '=?',
            hierarchyBusinessType: '=?',
            hierarchyId: '=?',
            hierarchyBranchItem: '=?',
            hierarchyLocationList: '=?',
            disabled: '=?',
            isAllServicesCategoriesSelected: '=?',
            isAllServicesSelected: '=?',
            nullIfEmpty: '=?',
            fullResponse: '=?'

        };
        // ng-model - selected services
        // categories - selected categories
        bindToController = true;
        controller = Meevo.Components.Controls.ServiceMoverController;
        controllerAs = '$ctrl';
        require = [
            'meevoServiceMover',
            'ngModel'
        ];
        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            self.ngModel = ngModel;
            self.init();
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new ServiceMover();
            };

            return directive;
        }
    }
    angular.module("meevo.components.controls")
        .directive("meevoServiceMover", ServiceMover.factory());
}